import Marquee from "react-fast-marquee";
import { TrendingUp, TrendingDown, Minus, IndianRupee } from "lucide-react";
import { fmt } from "@/hooks/useRates";

const TrendIcon = ({ change }) => {
  if (change > 0) return <TrendingUp size={13} className="text-[#00C851]" />;
  if (change < 0) return <TrendingDown size={13} className="text-[#FF3B30]" />;
  return <Minus size={13} className="text-white/40" />;
};

export default function Ticker({ rates, usdinr }) {
  return (
    <div
      data-testid="live-rates-ticker"
      className="sticky top-16 lg:top-20 z-40 border-y border-white/10 bg-[#0A0A0A]/90 backdrop-blur-xl flex items-stretch"
    >
      {usdinr && (
        <div
          data-testid="ticker-usdinr"
          className="hidden sm:flex items-center gap-1.5 px-5 bg-[#25D366] text-[#0A0A0A] font-ticker text-xs font-bold whitespace-nowrap"
        >
          <IndianRupee size={12} />
          1 USD = ₹{fmt(usdinr, 2)}
        </div>
      )}
      <Marquee speed={35} gradient={false} pauseOnHover className="py-3.5">
        {rates.length === 0 ? (
          <span className="px-8 font-ticker text-xs tracking-[0.25em] text-white/40 uppercase">
            Connecting to market feed…
          </span>
        ) : (
          rates.map((r) => (
            <span
              key={r.symbol}
              data-testid={`ticker-${r.symbol.toLowerCase()}`}
              className="mx-8 inline-flex items-center gap-3 font-ticker text-xs sm:text-sm tracking-[0.1em] uppercase"
            >
              <span
                className={
                  r.symbol === "COPPER" || r.symbol === "ALUMINIUM"
                    ? "text-[#25D366] font-semibold"
                    : "text-white/45"
                }
              >
                {r.symbol}
              </span>
              <span className="text-[#FDFDFD] font-semibold">₹{fmt(r.mcx, r.dec)}</span>
              {r.lme != null && <span className="text-white/50">${fmt(r.lme, r.lme_dec)}</span>}
              <span
                className={`inline-flex items-center gap-1 ${
                  r.mcx_change > 0 ? "text-[#00C851]" : r.mcx_change < 0 ? "text-[#FF3B30]" : "text-white/40"
                }`}
              >
                <TrendIcon change={r.mcx_change} />
                {Math.abs(r.mcx_change_pct).toFixed(2)}%
              </span>
              <span className="text-white/15">/</span>
            </span>
          ))
        )}
      </Marquee>
    </div>
  );
}
